import { api } from '@smena/ui';

export type ChannelName = 'telegram' | 'max' | 'vk' | 'webchat';
export type ChannelKind = 'shared' | 'custom';
export type ChannelConfigStatus = 'active' | 'inactive' | 'error';

export interface ChannelConfigView {
  id: string;
  accountId: string;
  channel: ChannelName;
  kind: ChannelKind;
  botUsername: string | null;
  hasBotToken: boolean;
  status: ChannelConfigStatus;
  lastError: string | null;
  createdAt: string;
  updatedAt: string;
}

export function fetchChannels(): Promise<{ items: ChannelConfigView[] }> {
  return api('/api/staff/channels');
}

export function upsertChannel(input: {
  channel: ChannelName;
  kind: ChannelKind;
  botToken?: string;
  botUsername?: string;
}): Promise<ChannelConfigView> {
  return api('/api/staff/channels', { method: 'POST', json: input });
}

export function deleteChannel(channel: ChannelName): Promise<{ ok: true }> {
  return api(`/api/staff/channels/${channel}`, { method: 'DELETE' });
}

/**
 * Включить/выключить канал. Отличается от deleteChannel: тот сносит настройку (свой бот
 * вместе с токеном) и возвращает аккаунт на общий бот Smena, а здесь канал просто перестаёт
 * предлагаться гостю - настройка остаётся.
 */
export function setChannelEnabled(channel: ChannelName, enabled: boolean): Promise<ChannelConfigView> {
  return api(`/api/staff/channels/${channel}/enabled`, { method: 'PATCH', json: { enabled } });
}
